import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { LoginComponent } from './features/auth/login/login.component';
import { DashboardLayoutComponent } from './layouts/dashboard-layout/dashboard-layout.component';

import { ErrorComponent } from './features/error/error.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: '',
    component: DashboardLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent
          ),
      },
      {
        path: 'donors',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/donors/donors.component').then(
                (m) => m.DonorsComponent
              ),
          },
          {
            path: 'details',
            loadComponent: () =>
              import(
                './features/donors/donor-details/donor-details.component'
              ).then((m) => m.DonorDetailsComponent),
          },
        ],
      },

      {
        path: 'projects',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/projects/root/projects.component').then(
                (m) => m.ProjectsComponent
              ),
          },
          {
            path: 'dashboard/:type/:id',
            loadComponent: () =>
              import(
                './features/projects/project-dashboard/project-dashboard.component'
              ).then((m) => m.ProjectDashboardComponent),
          },
          {
            path: 'details/:type',
            loadComponent: () =>
              import(
                './features/projects/project-details/project-details.component'
              ).then((m) => m.ProjectDetailsComponent),
          },
        ],
      },
      {
        path: 'settings',
        children: [
          {
            path: 'kiosks',
            children: [
              {
                path: '',
                loadComponent: () =>
                  import('./features/kiosks/kiosks.compoenent').then(
                    (m) => m.KiosksCompoenent
                  ),
              },
            ],
          },
          {
            path: 'users',
            loadComponent: () =>
              import(
                './features/user-management/user-management.component'
              ).then((m) => m.UserManagementComponent),
          },
          {
            path: 'permissions',
            loadComponent: () =>
              import('./features/permissions/permissions.component').then(
                (m) => m.PermissionsComponent
              ),
          },
          {
            path: 'notifications',
            children: [
              {
                path: '',
                loadComponent: () =>
                  import(
                    './features/notifications/notifications.components'
                  ).then((m) => m.NotificationsComponents),
              },
            ],
          },
          {
            path: 'screen-saver',
            children: [
              {
                path: '',
                loadComponent: () =>
                  import('./features/kiosk-videos/kiosk-videos.component').then(
                    (m) => m.KioskVideosComponent
                  ),
              },
            ],
          },
        ],
      },
      {
        path: 'app-info',
        children: [
          {
            path: 'contact-us',
            loadComponent: () =>
              import(
                './features/contact-us-managment/contact-us-managment.component'
              ).then((m) => m.ContactUsManagmentComponent),
          },
          {
            path: 'bank-accounts',
            loadComponent: () =>
              import(
                './features/bank-accounts-managment/bank-accounts-managment.component'
              ).then((m) => m.BankAccountsManagmentComponent),
          },
          {
            path: 'about-us',
            loadComponent: () =>
              import(
                './features/about-us-managment/about-us-managment.component'
              ).then((m) => m.AboutUsManagmentComponent),
          },
          {
            path: 'banner-management',
            loadComponent: () =>
              import(
                './features/other-info/other-info.component'
              ).then((m) => m.OtherInfoComponent),
          },
        ],
      },
    ],
  },

{
  path: 'error/403',
  component: ErrorComponent,
  data: { code: '403' }
},
{
  path: 'error/404',
  component: ErrorComponent,
  data: { code: '404' }
},
{
  path: 'error/500',
  component: ErrorComponent,
  data: { code: '500' }
},
{
  path: '**',
  redirectTo: 'error/404'
}

];
